export default __webpack_public_path__ + "static/media/mail-download.c4578583.gif";